import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_delete2",
  "use": "icon-map_delete2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_delete2\">\n<g id=\"icon-map_delete2_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 6 0.769531 C -2.859375 2.566406 2 18.523438 10.683594 15.683594 C 16.96875 13.589844 16.367188 -1.332031 6 0.769531 M 10 1 L 10 2 L 6 2 C 7.507813 1.316406 8.316406 1.175781 10 1 M 6 7 L 6 13 L 5 13 C 5 10.746094 5 9.050781 6 7 M 9 7 L 9 13 L 7 13 L 7 7 L 9 7 M 11 7 L 11 13 L 10 13 C 10 10.746094 10 9.050781 11 7 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_delete2.svg
// module id = T0PS
// module chunks = 24